import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConfirmacionComponent } from './confirmacion.component'; // Asegúrate de que este componente existe

const routes: Routes = [
  { path: '', component: ConfirmacionComponent } // Aquí debe estar la ruta correcta
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ConfirmacionRoutingModule {}
